import { useEffect, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { generateEmergementJournalier } from "../../api/docs";
import { getCycleOptionsForEmargement } from "../../api/settings";
import { Action, buildPermissionContext, Resource } from "../../core/common/autorisations/permissionsMap";

enum Cycle {
  LICENCE = "Licence",
  MASTER = "Master",
  DOCTORAT = "Doctorat",
}

const today = new Date();
const yyyy = today.getFullYear();
const mm = String(today.getMonth() + 1).padStart(2, "0");
const dd = String(today.getDate()).padStart(2, "0");
const initialDate = `${yyyy}-${mm}-${dd}`;

const EmargementJournalier = () => {
  // state pour le PDF
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string | null>(null);
  const [isFileLoading, setIsFileLoading] = useState(false); // Pour la génération de la fiche
  const [iframeVisible, setIframeVisible] = useState(false);
  const [selectedDay, setSelectedDay] = useState<string | null>(initialDate);
  const [selectedCycle, setSelectedCycle] = useState<Cycle | null>(null);
  const [allCycles, setAllCycles] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fontion pour générer un relevé denotes selon un jours et un cycle
  const generateEmargementJournalier = async () => {
    try {
      if (!selectedDay || !selectedCycle) {
        alert("Veuillez sélectionner un jour et un cycle.");
        return;
      }
      setIsFileLoading(true);
      // Appel API pour générer le PDF
      const response = await generateEmergementJournalier({
        date: selectedDay,
        cycle: selectedCycle,
      }, buildPermissionContext(Resource.EMARGEMENT, Action.CREATE));
      // console.log("releve generation : ", response);
      const blob = new Blob([response], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
      setIframeVisible(true);
      // console.log("relevé généré: ", response);
      toast.success("Fiche d'émargement journalier générée avec succès");
    } catch (error: any) {
      // console.log("erreur génération fiche d'émargement: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false);
      setIsFileLoading(false);
    }
  };

  const fetchAllCycle = async () => {
    try {
      const response = await getCycleOptionsForEmargement(
        buildPermissionContext(Resource.EMARGEMENT, Action.CREATE),
      );
      const cycles = Array.isArray(response)
        ? response
        : (response?.data ?? []);
      // console.log("Toutes les cycles: ", cycles);
      setAllCycles(cycles);
    } catch (error: any) {
      // console.log("erreur de chargement des cycles : ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
      // Option: reset les mémoires en cas d'erreur
      setAllCycles([]);
    }
  };

  useEffect(() => {
    fetchAllCycle();
  }, []);

  return (
    <>
      {/* Fiche d'émargement */}
      <div
        className="chat chat-messages"
        style={{ border: "1px solid #B5B9C3" }}
        id="middle"
      >
        {/* Entête */}
        <div
          className="chat-header"
          style={{ borderBottom: "1px solid #B5B9C3" }}
        >
          <div className="user-details">
            <div className="bg-primary-light rounded-circle p-2 me-3">
              <i className="ti ti-clipboard-check fs-4" />
            </div>
            <div>
              <h4>Fiche d'émargement Journalier</h4>
            </div>
          </div>
          <div className="chat-options">
            <ul className="list-inline">
              <li className="list-inline-item">
                <Link
                  className="btn btn-outline-light no-bg"
                  to="#"
                  data-bs-toggle="dropdown"
                >
                  <i className="bx bx-dots-vertical-rounded" />
                </Link>
                <div className="dropdown-menu dropdown-menu-end">
                  <Link to="#" className="dropdown-item">
                    <span>
                      <i className="bx bx-x" />
                    </span>
                    Close Chat
                  </Link>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Contenu remplacé par l'iframe */}
        {iframeVisible && pdfBlobUrl ? (
          <iframe
            src={pdfBlobUrl}
            style={{
              width: "100%",
              height: "calc(100vh - 80px)", // Ajustez selon la hauteur du header
              border: "none",
              marginTop: "10px",
            }}
            title="Aperçu PDF"
            onError={(e) => {
              // console.error("Erreur de chargement du PDF", e);
              // Gestion d'erreur optionnelle
            }}
          />
        ) : (
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{ height: "calc(100vh - 80px)" }}
          >
            {/* Version sobre */}
            <div className="text-center p-4">
              <div className="bg-light rounded-circle p-4 mb-3 d-inline-flex">
                <i className="bx bx-file-blank fs-1 text-muted"></i>
              </div>
              <h4 className="text-muted mb-2">
                {pdfBlobUrl ? "Chargement du PDF..." : "Aucun PDF à afficher"}
              </h4>
              <p className="text-muted">
                {!pdfBlobUrl && "Générez un nouveau PDF pour l'afficher ici"}
              </p>
            </div>
          </div>
        )}
      </div>
      {/* Sidebar Droit */}
      <div
        className="right-sidebar right_sidebar_profile right-side-contact show-right-sidebar"
        id="middle1"
        style={{ borderTop: "1px solid #B5B9C3" }}
      >
        <div className="right-sidebar-wrap active">
          <div className="slimscroll">
            <Scrollbars>
              <div className="sidebar-body">
                <div className="mt-0 right_sidebar_logo">
                  <div className="text-center right-sidebar-profile">
                    <div className="bg-primary-light rounded-circle p-2 me-3">
                      <i className="ti ti-clipboard-check fs-4" />
                    </div>
                    <h5 className="profile-name">Paramètres</h5>
                    <div className="last-seen-profile">
                      <span>Sélectionnez les options de la fiche</span>
                    </div>
                  </div>
                  <div className=" chat-member-details mb-2">
                    <label className="form-label">Sélectionner un jour</label>
                    <input
                      type="date"
                      className="form-control"
                      value={selectedDay || ""}
                      onChange={(e) => setSelectedDay(e.target.value)}
                    />
                    <br />
                    <label className="form-label">Sélectionner un Cycle</label>
                    <select
                      className="form-select"
                      value={selectedCycle || ""}
                      onChange={(e) =>
                        setSelectedCycle(e.target.value as Cycle)
                      }
                    >
                      <option value="">Sélectionner un Cycle</option>
                      {allCycles.map((cycle: any) => (
                        <option key={cycle?.id} value={cycle?.id}>
                          {cycle?.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="right-sidebar-head share-media">
                <div className="d-grid gap-2 mb-4">
                  {isFileLoading ? (
                    <button
                      className="btn btn-primary-light"
                      type="button"
                      disabled={false}
                    >
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Chargement...
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        generateEmargementJournalier();
                      }}
                      className="btn btn-primary"
                      type="button"
                    >
                      Génerer
                    </button>
                  )}
                </div>
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>
      {/* Sidebar Droit */}
    </>
  );
};
export default EmargementJournalier;
